import { render, staticRenderFns } from "./CheckboxInput.vue?vue&type=template&id=56587eac&scoped=true"
import script from "./CheckboxInput.vue?vue&type=script&lang=js"
export * from "./CheckboxInput.vue?vue&type=script&lang=js"
import style0 from "./CheckboxInput.vue?vue&type=style&index=0&id=56587eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56587eac",
  null
  
)

export default component.exports